import _ from 'lodash'

const TEXTAREA_ROWS = 3

export const FIELDSTYLES = [
    { value: 'regular', label: 'Regular' },
    { value: 'filled', label: 'Filled' },
    { value: 'outlined', label: 'Outlined' },
    { value: 'solo', label: 'Solo' }
]

export const FIELDS = {
    text: {
        label: 'Text',
        icon: 'mdi-form-textbox',
        hint: 'Einfacher einzeiliger Text'
    },
    textarea: {
        label: 'Mehrzeiliger Text',
        icon: 'mdi-text',
        hint: 'Texterfassung mit vorgegebener Anzahl von Zeilen',
        rows: TEXTAREA_ROWS
    },
    number: {
        label: 'Nummer',
        icon: 'mdi-form-textbox',
        hint: 'Nummer'
    },
    autocomplete: {
        label: 'Autovervollständigung',
        icon: 'mdi-feature-search-outline'
    },
    button: {
        label: 'Knopf',
        icon: 'mdi-cursor-default-click'
    },
    checkbox: {
        label: 'Auswahlbox',
        icon: 'mdi-checkbox-blank-outline'
    },
    switch: {
        label: 'Auswahlschalter',
        icon: 'mdi-toggle-switch'
    },
    radio: {
        label: 'Auswahlliste',
        icon: 'mdi-radiobox-marked',
        hint: 'Auswahl aus einer Liste von Möglichkeiten',
        multiple: false
    },
    combobox: {
        label: 'Mehrfachauswahl',
        icon: 'mdi-format-list-checks',
        multiple: true
    },
    select: {
        label: 'Selektion',
        icon: 'mdi-arrow-down-drop-circle'
    },
    date: {
        label: 'Datum',
        icon: 'mdi-calendar'
    },
    time: {
        label: 'Uhrzeit',
        icon: 'mdi-clock'
    },
    password: {
        label: 'Passwort',
        icon: 'mdi-form-textbox-password'
    },
    phone: {
        label: 'Telefon',
        icon: 'mdi-phone'
    },
    email: {
        label: 'E-Mail',
        icon: 'mdi-email-outline'
    },
    slider: {
        label: 'Bereich',
        icon: 'mdi-ray-start-end',
        min: 0,
        max: 5,
        hint: 'Auswahl aus einem Wertebereich von Min bis Max'
    },
    range: {
        label: 'Von-bis Bereich',
        icon: 'mdi-ray-start-end',
        min: 0,
        max: 24,
        value: [9, 17],
        hint: 'Auswahl aus einem Wertebereich von ... bis'
    },
    rating: {
        label: '5 Sterne',
        icon: 'mdi-star',
        hint: 'Standard 5 Sterne Bewertung'
    },
    infotext: {
        label: 'Infotext',
        icon: 'mdi-comment',
        hint: 'Fest hinterlegter und nicht bearbeitbarer Text'
    },
    sparkline: {
        label: 'Diagramm',
        icon: 'mdi-chart-line',
        hint: 'Zeitlicher Verlauf von Werten'
    },
    spacer: {
        label: 'Platzhalter',
        icon: 'mdi-arrow-up-down-bold-outline',
        hint: 'Leeres Feld'
    },
    gap: {
        label: 'Absatz',
        icon: 'mdi-arrow-up-down-bold-outline',
        hint: ''
    },
    divider: {
        label: 'Zwischenüberschrift',
        icon: 'mdi-minus',
        hint: 'Überschrift mit Trennlinie'
    },
    subheader: {
        label: 'Überschrift',
        icon: 'mdi-page-layout-header',
        hint: 'Text für Gruppierung von Feldern'
    },
    note: {
        label: 'Schulnote',
        icon: 'mdi-music-note',
        hint: 'Vergabe einer Schulnote 1-6'
    },
    duration: {
        label: 'Dauer',
        icon: 'mdi-timer',
        hint: 'hh:mm:ss'
    },
    link: {
        label: 'Link',
        icon: 'mdi-link',
        hint: 'Verweis auf eine andere Seite',
        placeholder: 'https://'
    }
}

export function buildTreeItems(types, i18n) {
    const treeItems = []
    treeItems.push(buildGroupHeader(types, i18n))
    treeItems.push(buildGroupText(types, i18n))
    treeItems.push(buildGroupSelect(types, i18n))
    treeItems.push(buildGroupRating(types, i18n))
    return treeItems
}
const buildGroupText = (types, i18n) => {
    const _mapField = _.partial(mapField, i18n)
    const fieldTypes = ['email', 'phone', 'date', 'time', 'password', 'number', 'link']
    const groupText = {
        id: 'grouptext',
        label: i18n('groups.text'),
        children: []
    }

    if (!types || types.includes('text')) {
        groupText.children.push({id: 'text', type: 'text', ..._mapField(FIELDS.text, 'text')})
    }
    if (!types || types.includes('textarea')) {
        groupText.children.push({id: 'textarea', type: 'textarea', ..._mapField(FIELDS.textarea, 'textarea')})
    }

    const pickTypes = !types ? fieldTypes : _.filter(fieldTypes, type => types.includes(type))
    if (pickTypes) groupText.children.push({
        id: 'texttypes',
        label: i18n('groups.predefined'),
        children: _.map(_.pick(FIELDS, pickTypes), (field, type) => {
            field = _mapField(field, type)
            field.rating = false
            return field
        })
    })

    return groupText
}
const buildGroupSelect = (types, i18n) => {
    const _mapField = _.partial(mapField, i18n)
    const fieldTypes = ['checkbox', 'switch', 'combobox', 'autocomplete', 'radio', 'select']
    const pickTypes = !types ? fieldTypes : _.filter(fieldTypes, type => types.includes(type))
    return {
        id: 'groupselect',
        label: i18n('groups.select'),
        children: _.map(_.pick(FIELDS, pickTypes), _mapField)
    }
}
const buildGroupRating = (types, i18n) => {
    const _mapField = _.partial(mapField, i18n)
    const fieldTypes = ['slider', 'range', 'note', 'rating']
    const pickTypes = !types ? fieldTypes : _.filter(fieldTypes, type => types.includes(type))
    return {
        id: 'grouprating',
        label: i18n('groups.range'),
        children: _.map(_.pick(FIELDS, pickTypes), _mapField)
    }
}
const buildGroupHeader = (types, i18n) => {
    const _mapField = _.partial(mapField, i18n)
    const fieldTypes = ['subheader', 'divider', 'gap']
    const pickTypes = !types ? fieldTypes : _.filter(fieldTypes, type => types.includes(type))
    return {
        id: 'groupheader',
        label: i18n('groups.header'),
        children: _.map(_.pick(FIELDS, pickTypes), _mapField)
    }
}
// translate field label and hint
// NOTE could be used to change icon, currently disabled
const mapField = (i18n, field, type) => {
    field.type = type
    field.id = type
    if (_.has(field, 'label')) field.label = i18n(`fields.${type}.label`)
    if (_.has(field, 'hint')) field.hint = i18n(`fields.${type}.hint`)
    // field.icon = i18n(`fields.${type}.icon`)
    return field
}

const props = {
    name: {
        name: 'name',
        label: 'Name',
        size: 6,
        required: true,
        autofocus: true,
        hint: 'Name'
    },
    label: {
        name: 'label',
        label: 'Titel',
        size: 6,
        required: true,
        hint: 'Der Titel des Bausteins'
    },
    type: {
        name: 'type',
        label: 'Type',
        size: 4,
        hint: 'Type'
    },
    placeholder: {
        name: 'placeholder',
        label: 'Platzhalter',
        size: 6,
        hint: 'Der Platzhalter für die Eingabe'
    },
    hint: {
        name: 'hint',
        label: 'Hilfetext',
        type: 'textarea',
        rows: 3,
        size: 12,
        hint: 'Der Hilfetext unterhalb des Bausteins'
    },
    fieldstyle: {
        name: 'fieldstyle',
        label: 'Fieldstyle',
        type: 'radio',
        value: 'regular',
        hint: 'look of the controls',
        hideDetails: true,
        items: FIELDSTYLES
    },
    required: {
        name: 'required',
        label: 'Pflichtfeld?',
        hint: 'Eine Eingabe ist zwingend erforderlich',
        size: 12,
        type: 'checkbox'
    },
    readonly: {
        name: 'readonly',
        hint: 'Nur lesen?',
        size: 3,
        type: 'checkbox'
    },
    autofocus: {
        name: 'autofocus',
        hint: 'Automatisch fokussieren?',
        size: 3,
        type: 'checkbox'
    },
    clearable: {
        name: 'clearable',
        hint: 'Löschhilfe?',
        size: 3,
        type: 'checkbox'
    },
    min: {
        name: 'min',
        hint: 'Minimum',
        size: 4,
        type: 'number'
    },
    max: {
        name: 'max',
        hint: 'Maximum',
        size: 4,
        type: 'number'
    },
    tickLabels: {
        name: 'tickLabels',
        hint: 'Berechnete Auswahlmöglichkeiten',
        size: 12,
        disabled: true,
        clearable: false
    },
    customLabels: {
        name: 'customLabels',
        hint: 'Individuelle Auswahlmöglichkeiten mit Komma getrennt erfassen',
        size: 12,
        prependInnerIcon: 'mdi-keyboard-outline'
    },
    items: {
        name: 'items',
        hint: 'Auswahlmöglichkeiten. Auswahl anklicken zur Bearbeitung.',
        size: 12,
        type: 'combobox',
        editable: true
    },
    multiple: {
        name: 'multiple',
        label: 'Mehrfachauswahl',
        size: 6,
        type: 'checkbox'
    },
    rows: {
        name: 'rows',
        hint: 'Anzahl sichtbarer Zeilen',
        size: 4,
        type: 'number'
    },
    subheader: {
        name: 'subheader',
        size: 12,
        type: 'text'
    },
    row: {
        name: 'row',
        label: 'Horizontal anordnen?',
        hint: 'Die Auswahlmöglichkeiten können neben- oder untereinander angezeigt werden.',
        size: 6,
        type: 'checkbox',
        value: true
    },
    step: {
        name: 'step',
        hint: 'Schrittweite',
        size: 4,
        type: 'number',
        value: 1
    }
}

const _PROPS = {
    text: [
        ['name', 'label'],
        ['placeholder', 'hint'],
        ['fieldstyle'],
        ['required', 'readonly', 'clearable', 'autofocus']
    ],
    textarea: [
        ['name', 'label'],
        ['placeholder', 'hint'],
        ['fieldstyle'],
        ['required', 'readonly', 'clearable', 'autofocus'],
        ['rows']
    ],
    email: [
        ['name', 'label'],
        ['placeholder', 'hint'],
        ['fieldstyle'],
        ['required']
    ],
    slider: [['name', 'label'], ['hint'], ['min', 'max', 'step']],
    range: [['name', 'label'], ['hint'], ['min', 'max']],
    switch: [['name', 'label'], ['hint'], ['required']],
    checkbox: [['name', 'label'], ['hint'], ['required']],
    radio: [['name', 'label'], ['hint'], ['items'], ['multiple'], ['row']],
    combobox: [['name', 'label'], ['hint'], ['items'], ['multiple'], ['required']],
    subheader: [['name', 'label']],
    divider: [['name', 'label']],
    rating: [],
    gap: []
}

export default {
    props(type, defaults = {}, exclude = [], i18n) {
        defaults.type = type
        const typeProps = _PROPS[type] || _PROPS['text']
        const rows = []
        _.each(typeProps, (row) => {
            const trow = []
            _.each(row, (r) => {
                if (props[r] && !_.includes(exclude, r)) {
                    const p = _.cloneDeep(props[r])
                    if (!_.isUndefined(defaults[r])) p.value = defaults[r]
                    if (i18n && _.has(p, 'label')) p.label = i18n(`props.${r}.label`)
                    if (i18n && _.has(p, 'hint')) p.hint = i18n(`props.${r}.hint`)
                    trow.push(p)
                }
            })
            rows.push(trow)
        })
        return rows
    },
    text(defaults = {}, exclude = []) {
        return this.props('text', defaults, exclude)
    },
    checkbox(defaults = {}, exclude = []) {
        return this.props('checkbox', defaults, exclude)
    },
    type(type) {
        return _PROPS[type] || _PROPS['text']
    }
}
